@if (!jssPlatform.isEditorActive()) {
  @for (placeholder of placeholders(); track placeholder) {
    <sc-placeholder
      (loaded)="triggerLoaded($event)"
      [name]="placeholder"
      [rendering]="componentRendering()!"
    ></sc-placeholder>
  } @empty {
    <sc-placeholder
      (loaded)="triggerLoaded($event)"
      [name]="fallbackPlaceholder"
      [rendering]="componentRendering()!"
    ></sc-placeholder>
  }
} @else {
  @for (placeholder of placeholders(); track placeholder) {
    <sc-placeholder
      ngSkipHydration
      (loaded)="triggerLoaded($event)"
      [name]="placeholder"
      [rendering]="componentRendering()!"
    ></sc-placeholder>
  } @empty {
    <!-- This should never happen, but just in case it does, we log an error and try to render "entry" as fallback -->
    <sc-placeholder
      ngSkipHydration
      (loaded)="triggerLoaded($event)"
      [name]="fallbackPlaceholder"
      [rendering]="componentRendering()!"
    ></sc-placeholder>
  }
}
